import React from 'react';
import AlertFormBasicContainer from "./AlertFormBasicContainer"
const AlertFormBasic = (props) => (
    <AlertFormBasicContainer {...props} />
);
export default AlertFormBasic;
